export default __webpack_public_path__ + "static/media/ventilacion.3e17a58c.svg";